module.exports = __webpack_public_path__ + "static/media/back.6fc8122f.svg";